import React from 'react';

class HowTo extends React.Component {
	render() {
		return (
			<div>
				<p><strong>Hur fungerar det?</strong></p>
				<p>Försäljningen sker genom Swish så se till att köparen har sin smartphone redo.</p>
				<ol>
					<li>Klicka på "Sälj andelar" på startsidan.</li>
					<li>Välj antalet andelar som köparen vill ha.</li>
					<li>Visa upp QR-koden för användaren.</li>
					<li>Användaren scannar av QR-koden med sin smartphone och genomför sin betalning.</li>
					<li>Du får upp ett meddelande när köpet är genomfört.</li>
				</ol>
				<p>Obs! Om något går fel så är det bara att avbryta och börja om från början.</p>

				<div style={{ marginTop: '40px', textAlign: 'center' }}>
					<div onClick={ () => this.props.parent.setState({ page: 'home' }) } className="button pink2-invert auto-width">Tillbaka</div>
				</div>
			</div>
		)
	}
}
export default HowTo;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/HowTo.js